import { useMemo } from "react";
import styles from "./SimulationTable.module.css";
import { Table } from "@/components/common/table/Table";
import type {
    ColumnDef,
    tableProps,
} from "@/components/common/table/types.props";
import type { simulation } from "@/features/dashboard/types.api";

const StateBadge = ({
    state,
    stateDisplay,
}: {
    state?: string;
    stateDisplay?: string;
}) => {
    const stateClass = styles[`badge-${state}`] || styles["badge-default"];
    return (
        <span className={`${styles.badge} ${stateClass}`}>{stateDisplay}</span>
    );
};

type simulationTableProps = Omit<tableProps<simulation>, "columns">;

export const SimulationTable: React.FC<simulationTableProps> = ({
    data,
    isLoading,
    actions,
}) => {
    const columns = useMemo<ColumnDef<simulation>[]>(
        () => [
            { accessorKey: "name", header: "Nombre" },
            {
                accessorKey: "created_at",
                header: "Fecha de creación",
                cell: (sim) => (sim.created_at ? sim.created_at.split("T")[0] : ""),
            },
            {
                accessorKey: "updated_at",
                header: "Última actualización",
                cell: (sim) => (sim.updated_at ? sim.updated_at.split("T")[0] : ""),
            },
            {
                accessorKey: "type",
                header: "Tipo",
                cell: (sim) => sim.type || "",
            },
            {
                accessorKey: "state",
                header: "Estado",
                cell: (sim) => (
                    <StateBadge state={sim.state} stateDisplay={sim.state_display} />
                ),
            },
        ],
        [],
    );

    return (
        <Table<simulation>
            columns={columns}
            data={data}
            isLoading={isLoading}
            actions={actions}
        />
    );
};
